import { Button } from 'antd';
import React from 'react';

export const OptionButton = ({ answer, correctAnswer, correctAnswers, disabled, onClick, selectedAnswer }) => {
    const isAnswered = !!selectedAnswer;
    const isCorrect = correctAnswers
        ? typeof correctAnswers.has === 'function'
            ? correctAnswers.has(answer)
            : correctAnswers.includes(answer)
        : answer === correctAnswer;
    const isSelected = answer === selectedAnswer;

    return (
        <Button
            block
            size="large"
            disabled={disabled}
            type={isAnswered && isCorrect ? 'primary' : 'default'}
            danger={isAnswered && isSelected && !isCorrect}
            style={{
                minHeight: 46,
                whiteSpace: 'normal',
                height: 'auto',
                padding: '10px 14px',
                ...(isAnswered && isCorrect ? { background: '#389e0d', borderColor: '#389e0d' } : {}),
            }}
            onClick={onClick}
        >
            {answer}
        </Button>
    );
};
